<template>
<div>
<SearchResult/>

</div>
</template>

<script>
import SearchResult from "../../components/Event/SearchResult.vue";


export default {
  components: {
   SearchResult
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>